<template>
  <component
    :is="link?.startsWith('/') && !hasLinks ? 'NuxtLink' : 'button'"
    :target="isExternal ? '_blank' : undefined"
    class="cursor-pointer font-avuText text-xl text-avu-black transition duration-200 ease-in-out hover:text-avu-blue hover:underline hover:underline-offset-8 sm:text-[22px]/[26px] xl:text-[26px]/[30px]"
    @click="handleClick"
  >
    <span v-html="text" />
  </component>
</template>

<script setup>
  const props = defineProps(["text", "link", "hasLinks"]);
  const router = useRouter();

  const isExternal = computed(() => /^(http|https|\/\/)/.test(props.link));

  const handleClick = () => {
    if (props.hasLinks) {
      return;
    }

    if (props.link && props.link.startsWith("/")) {
      router.push(props.link);
    }
  };
</script>
